// import {combineReducers} from 'redux';
import {
	CHAT_INIT,
	CHAT_LOAD,
	CHAT_CLOSE_UI,
	CHAT_RECONNECT,
	CHAT_DISCONNECT,
	CHAT_NB_CONNECTED_USERS,
	CHAT_MOBILE_PANEL,
	CHAT_INIT_ERROR,
	CHAT_TOGGLE_NOTIFICATION_FORM,
	CHAT_TOGGLE_ASK_FORM,
	CHAT_WILL_END,
	CHAT_ENDED,
	CHAT_SOUND_PLAY,
	CHAT_SOUND_PLAYED,
	WELCOME_SURVEY_TOGGLE_NOTIFICATION_PANEL,
	WELCOME_SURVEY_SUBMIT

} from '../actions/chatInitAction';

export default function (initialState={
	loaded: false,
	closed: false,
	id: null,
	serverUrl: null,
	lastPing: null,
	// insiders: {}, // all connected insiders to show
    connectedUsersCount: 0,
    isNotificationFormOpened: false,
    isAskFormOpened: false,
	mobilePanels: {
		'filters':        'panel_out prev',
		'threads':        'panel_out prev',
		'messages':       'panel_out prev',
		'welcomehelper':  'panel_in',
		'thread_form':    'panel_out next',
		'insider_form':   'panel_out next',
		'admin_activity': 'panel_out next'
	},
	mobileSelected: 'welcomehelper',
	soundToPlay: false,
	chatURL: null,
	chatLoginURL: null,
	appType: null,
	welcomeSurvey: {
      itemClass: {
        'survey-panel': true,
        'alert-panel': true,
        'slideDown': true
      }
  	}
}, action) {

	switch (action.type) {
		case CHAT_INIT: {
			return {
				...initialState,
				id: action.payload.livechatId,
				serverUrl: action.payload.serverUrl
			}
		}
		case CHAT_LOAD: {
			return {...initialState, loaded: true, closed: false, ...action.payload}
			break;
		}

		case CHAT_RECONNECT: {
			break;
		}

		case CHAT_DISCONNECT: {
			break;
		}

		case CHAT_CLOSE_UI: {
			return {...initialState, closed: true}
		}

		case CHAT_MOBILE_PANEL: {
			return {...initialState, ...action.payload}
		}

		case CHAT_TOGGLE_NOTIFICATION_FORM: {
        	return {...initialState, isNotificationFormOpened: action.isNotificationFormOpened}
      	}

      	case CHAT_TOGGLE_ASK_FORM: {

	      let isAskFormOpened = action.payload;
	      if (!isAskFormOpened || isAskFormOpened !== true || isAskFormOpened !== false){
	        isAskFormOpened = !(initialState.isAskFormOpened);
	      }
	      return {...initialState, isAskFormOpened: isAskFormOpened};
	    }

		case CHAT_NB_CONNECTED_USERS: {
			return {...initialState, connectedUsersCount: action.payload}
		}


		case CHAT_WILL_END: {
			// process a POST request into the chatMiddleware
		}

		case CHAT_ENDED: {
			return { ...initialState, closed: true }
		}

		case CHAT_INIT_ERROR: {
			break;
		}

		case CHAT_SOUND_PLAY: {
			return { ...initialState, soundToPlay: action.sound }
		}

		case CHAT_SOUND_PLAYED: {
			return { ...initialState, soundToPlay: false }
		}

		case WELCOME_SURVEY_TOGGLE_NOTIFICATION_PANEL: {

			let welcomeSurvey = initialState.welcomeSurvey;
	        let itemClass = welcomeSurvey.itemClass;
	        let slideDown = typeof action.state == 'undefined' ?  !(itemClass['slideDown']) : action.state;

	        itemClass = {...itemClass, slideDown };
	        welcomeSurvey = {...welcomeSurvey, itemClass};

	        return {...initialState, welcomeSurvey}
		}

		case WELCOME_SURVEY_SUBMIT: {
			// process a POST request into the chatMiddleware
		}

	}
	return initialState;
}



// WEBPACK FOOTER //
// ./src/redux/reducers/chatInitReducer.jsx